<template>
  <div class="body-wrap">
    <!-- 搜索 -->
    <div class="search-wrap" >
      <SelectCdjProjectHeader ref="selectCdjProjectHeaderRef" @onHeader="onHeader" :items="['type_id','region_id','project_id']"></SelectCdjProjectHeader>
      <div class="opt-wrap">
        <el-button size="mini" type="primary" @click="getList(1)" :loading="searchLoading">搜索</el-button>
        <el-button size="mini" type="primary" @click="openSaveDialog()" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" type="primary" @click="download('template/能耗非资金导入模版.xlsx')">下载导入模版</el-button>
      </div>
    </div>

    <!-- 数据列表 -->
    <div class="table-wrap" >
      <el-table border v-loading="searchLoading" :data="tableData" row-key="id">
        <el-table-column prop="project_name" label="所属项目" align="center"></el-table-column>
        <el-table-column prop="year_month" label="所属日期" align="center"></el-table-column>
        <el-table-column prop="amount" label="非垫付金额(元)" align="center"></el-table-column>
        <el-table-column prop="user_name" label="创建人" align="center"></el-table-column>
        <el-table-column prop="created_at" label="创建日期" align="center"></el-table-column>
        <el-table-column prop="updated_at" label="修改日期" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination
        size="mini"
        background
        @current-change="getList"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
      ></el-pagination>
    </div>
    <SaveView
      ref="saveRef"
      @close="getList"
    />
  </div>
</template>

<script>
import SaveView from './save.vue'
import SelectCdjProjectHeader from "@/components/Admin/Butler/projectCollectionTemplate/SelectCdjProjectHeader.vue";
export default {
  components: { SaveView, SelectCdjProjectHeader },
  data(){
    return{
      keyword: '',
      form: {},
      searchLoading:  false,
      page: 1,
      pageSize: 20,
      tableData: [],
      total: 0,
      selectCdjProjectHeaderRef: null,
      url: ''
    }
  },
  mounted() {
    this.url = process.env.NODE_ENV === 'development' ? window.Glob.meterDev : window.Glob.meterApi
    this.getList()
  },
  methods:{
    getList(p) {
      if(p)this.page = p
      var params = this.form
      params.page = this.page
      params.page_size = this.pageSize
      params.keyword = this.keyword
      this.$myhttp.post(this.url + 'meter/MeterNonAdvance/getList', params).then(resp => {
        let res = resp.data
        if(res.code == 1) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    openSaveDialog(data) {
      this.$refs.saveRef.show(data)
    },
    onHeader(data) {
      this.form.cdProject = data
    },
    download( url) {
      window.open(this.url + url)
    }
  }
}
</script>

<style lang="scss" scoped>

.body-wrap {
  padding: 10px;
}

.search-wrap {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
}

.pagination-wrap {
  display: flex;
  justify-content: end;
  margin-top: 10px;
}

.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/meterNonAdvance/index.vue